import { parseISO } from "date-fns"
import { ONBOARDING_DEFAULT_FORM_VALUES } from "../constants/onboardingDefaultFormValues"
import { type OnboardingSerializedState, type OnboardingState } from "../types/onboardingState"

const parseDate = (isoDate: string | null): Date | null => (isoDate ? parseISO(isoDate) : null)

const serializeDate = (date: Date | null): string | null => date?.toISOString() ?? null

// Migrate cookies written before invoiceUpload was nested: amountDue/extractionUuid were flat on the energy object
const migrateInvoiceUpload = (energy: Record<string, unknown>): Record<string, unknown> => {
    if ("invoiceUpload" in energy) return energy
    const { amountDue, extractionUuid, ...rest } = energy

    return {
        ...rest,
        invoiceUpload: {
            amountDue: amountDue ?? null,
            isInvoiceOld: null,
            extractionUuid: extractionUuid ?? null,
        },
    }
}

export const deserializeState = (
    serializedOnboardingState: OnboardingSerializedState
): OnboardingState => {
    const { electricity, gas } = serializedOnboardingState.formValues

    return {
        ...serializedOnboardingState,
        formValues: {
            ...serializedOnboardingState.formValues,
            // Cookies written before the effy fields existed don't have them
            effy: {
                ...ONBOARDING_DEFAULT_FORM_VALUES.effy,
                ...serializedOnboardingState.formValues.effy,
            },
            electricity: migrateInvoiceUpload(
                electricity as unknown as Record<string, unknown>
            ) as typeof electricity,
            gas: migrateInvoiceUpload(gas as unknown as Record<string, unknown>) as typeof gas,
            dateOfBirth: parseDate(serializedOnboardingState.formValues.dateOfBirth),
            requestedSupplyStartDate: parseDate(
                serializedOnboardingState.formValues.requestedSupplyStartDate
            ),
            requestedSupplyEndDate: parseDate(
                serializedOnboardingState.formValues.requestedSupplyEndDate
            ),
        },
    }
}

export const serializeState = (onboardingState: OnboardingState): OnboardingSerializedState => {
    return {
        ...onboardingState,
        formValues: {
            ...onboardingState.formValues,
            dateOfBirth: serializeDate(onboardingState.formValues.dateOfBirth),
            requestedSupplyStartDate: serializeDate(
                onboardingState.formValues.requestedSupplyStartDate
            ),
            requestedSupplyEndDate: serializeDate(
                onboardingState.formValues.requestedSupplyEndDate
            ),
        },
    }
}
